// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__3xQir","btnPageIndex":"Pagination_btnPageIndex__hVit_","enabled":"Pagination_enabled__24FRY","selected":"Pagination_selected__2wwa8"};